/* eslint-disable no-unused-vars */
import React from 'react';
import { useIntl } from 'react-intl';
import DataBox from '../../../Dashboard/DataBox';
import { Box, useTheme } from '@mui/material';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import CancelRoundedIcon from '@mui/icons-material/CancelRounded'; // import GraphsLegend from '../../../../Components/Charts/GraphsLegend';
import { ParentSize } from '@visx/responsive';
import BarChart from '../../../../Components/Charts/BarChart';
import TooltipComponent from './TooltipComponent';
const BranchCountersWidget = function BranchCountersWidget({ branchCounters }) {
  const intl = useIntl();
  const theme = useTheme();

  // One object per branch with both stacked values as separate keys
  const firstColumnsItems = branchCounters?.map((d) => ({
    label: d?.name,
    totalCallCount: d?.callCount,
    unansweredCallCount: d?.unansweredCallCount,
    uniqueUnansweredNumbersCount: d?.uniqueUnansweredNumbersCount,
    details: d?.details,
  }));

  const firstColumnKeys = [
    'unansweredCallCount',
    'uniqueUnansweredNumbersCount',
  ];
  const firstColumnColors = ['#CAFFBF', '#A0C4FF'];

  const secondColumnsItems = branchCounters?.map((d, index) => ({
    index: index + 1,
    label: d?.name,
    uniqueCallAgainAnsweredNumbersCount: d?.uniqueCallAgainAnsweredNumbersCount,
    uniqueRecalledNumbersCount: d?.uniqueRecalledNumbersCount,
    uniqueUnhandlableCallerNumber: d?.uniqueUnhandlableCallerNumber,
    uniqueRecalledNumbersNotAnsweredCount:
      d?.uniqueRecalledNumbersNotAnsweredCount,
    uniqueUnmanagedUnansweredNumbersCount:
      d?.uniqueUnmanagedUnansweredNumbersCount,
    target: d?.uniqueUnansweredNumbersCount,
  }));

  const secondColumnKeys = [
    'uniqueCallAgainAnsweredNumbersCount',
    'uniqueRecalledNumbersCount',
    'uniqueRecalledNumbersNotAnsweredCount',
    'uniqueUnhandlableCallerNumber',
    'uniqueUnmanagedUnansweredNumbersCount',
  ];
  const secondColumnColors = [
    '#B5EAD7',
    '#ffcf81',
    '#FFC6FF',
    '#ffac81',
    '#bf4324',
  ];
  return (
    <DataBox
      title={intl.messages.TOTAL_CALLS_RECEIVED_BY_BRANCH}
      widget={
        <>
          {/*   <Box display="flex" justifyContent="flex-end" paddingBottom="16px">
            <GraphsLegend
              flexDirection="row"
              legendData={[
                ...firstColumnKeys.map(
                  (key) => intl.messages[key.toUpperCase()] ?? key
                ),
                ...secondColumnKeys.map(
                  (key) => intl.messages[key.toUpperCase()] ?? key
                ),
              ]}
              legendColor={[...firstColumnColors, ...secondColumnColors]}
            />
          </Box> */}
          <Box
            sx={{
              width: "auto",
              height: "50vh"
            }}>
            <ParentSize>
              {(parent) => (
                //parent component passes his css properties to BarChart
                (<BarChart
                  stacked={[false, true]}
                  width={parent.width}
                  height={parent.height}
                  dataToShow={[firstColumnsItems, secondColumnsItems]}
                  keys={[firstColumnKeys, secondColumnKeys]}
                  colors={[firstColumnColors, secondColumnColors]}
                  TooltipContent={TooltipComponent}
                  renderTargetIcon={({ x, y, data, index }) => {
                    if (!data?.target) return null; //if no unansweredCallCount, no icon
                    let status = 'success';
                    let color = theme.palette.success.main;
                    if (data?.uniqueUnmanagedUnansweredNumbersCount) {
                      status = 'error';
                      color = theme.palette.error.main;
                    } else if (data?.uniqueRecalledNumbersNotAnsweredCount) {
                      status = 'warning';
                      color = theme.palette.warning.main;
                    }

                    const size = 36;

                    return (
                      // <foreignObject
                      //   x={x - size / 2}
                      //   y={y - size / 2}
                      //   width={size}
                      //   height={size}
                      // >
                      //   {status !== 'error' ? (
                      //     <CheckCircleRoundedIcon
                      //       color={status}
                      //       sx={{ fontSize: size }}
                      //     />
                      //   ) : (
                      //     <CancelRoundedIcon
                      //       color={status}
                      //       sx={{ fontSize: size }}
                      //     />
                      //   )}
                      // </foreignObject>
                      <text
                        key={`target-icon-${index}`}
                        x={x}
                        y={y + size / 2}
                        textAnchor="middle"
                        fontSize={size}
                        fontWeight="bold"
                        fill={color}
                      >
                        {status !== 'error' ? '✓' : '✗'}
                      </text>
                    );
                  }}
                />)
              )}
            </ParentSize>
          </Box>
        </>
      }
    />
  );
};

export default BranchCountersWidget;
